import { MANAGEMENT_FRAME_BREAKPOINT } from './types/management-frame-variants-enums';
export function getDesktopVisibilityClasses(breakpoint: MANAGEMENT_FRAME_BREAKPOINT): string {
  switch (breakpoint) {
    case MANAGEMENT_FRAME_BREAKPOINT.SM:
      return 'hidden sm:block';
    case MANAGEMENT_FRAME_BREAKPOINT.MD:
      return 'hidden md:block';
    case MANAGEMENT_FRAME_BREAKPOINT.LG:
      return 'hidden lg:block';
  }
}

export function getMobileVisibilityClasses(breakpoint: MANAGEMENT_FRAME_BREAKPOINT): string {
  switch (breakpoint) {
    case MANAGEMENT_FRAME_BREAKPOINT.SM:
      return 'block sm:hidden';
    case MANAGEMENT_FRAME_BREAKPOINT.MD:
      return 'block md:hidden';
    case MANAGEMENT_FRAME_BREAKPOINT.LG:
      return 'block lg:hidden';
  }
}
